/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { CoreErrorKey } from '../key/core-error.key';
import { ApplicationError } from '../model/application-error.model';
import { ObservableCollection } from '../util/observable-collection.util';
import { toValues } from './to-values.helper';

export function toArray<V>(
  source: Iterable<V> | Map<any, V> | ObservableCollection<any, V> | object,
): V[] {
  if (Array.isArray(source)) {
    return source;
  }
  if (source === undefined || source === null) {
    return [];
  }
  if (typeof source !== 'object') {
    throw new ApplicationError({
      key: CoreErrorKey.SOURCE_INVALID,
      arguments: { source }
    });
  }
  const array = new Array<V>();
  for (const value of toValues(source)) {
    array.push(value);
  }
  return array;
}
